import { SelectListItem } from '@factorialco/deprecated-design-system'

import type { SelectedAction } from 'modules/automations/components/AddAutomationBlockModal/types'

import Illustration from './Illustration'

export interface Props {
  action: SelectedAction
  label: string
  actionableType: string
  selected: boolean
  setSelected: (action: SelectedAction) => () => void
}

export default function Item({ action, label, actionableType, selected, setSelected }: Props) {
  return (
    <SelectListItem
      illustration={Illustration({
        actionableType,
        selected,
      })}
      selected={selected}
      label={label}
      onClick={setSelected(action)}
    />
  )
}
